import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ContentUtil } from '../../../utils/content/content.util';
import { environment } from 'src/environments/environment';
import { GranteeContent } from '../../../utils/content/aem-content-types';
import { AdobeTagging } from '../../../utils/decorators/dev/adobe-launch';
import { VgnService } from '../../../services/vgn/vgn.service';
import { configData } from './grantee-web-reg-page-adobe';
import { Observable, Subscription, take } from 'rxjs';
import { AccessTypeSelection } from '../../../../common/enums/access-type-selection.enum';
import { selectGranteeAccessType } from '../../../store/selectors/grantee.selector';
import { Store } from '@ngrx/store';
import { ZciCookieService } from 'src/app/services/zci-cookie/zci-cookie.service';
import { ButtonModule } from '@vg-constellation/angular-20/button';

@AdobeTagging(configData)
@Component({
    selector: 'zci-grantee-web-reg-page',
    templateUrl: './grantee-web-reg-page.component.html',
    styleUrls: ['./grantee-web-reg-page.component.scss'],
    imports: [ButtonModule],
})
export class GranteeWebRegPageComponent implements OnInit, OnDestroy {
    private readonly vgnService = inject(VgnService);
    private readonly store = inject(Store);
    private readonly cookieService = inject(ZciCookieService);

    readonly accessTypeSelection = AccessTypeSelection;

    content: GranteeContent = ContentUtil.granteeFragmentsContent;
    environment = environment;

    readonly subs: Subscription = new Subscription();

    granteeAccessType$: Observable<AccessTypeSelection> =
        this.store.select(selectGranteeAccessType);

    ngOnInit(): void {
        this.vgnService.setMinimalNav(true);
        this.adobePageLoad();
        this.subs.add(this.cookieService.clearLogonCookiesPublic().subscribe());
    }

    ngOnDestroy(): void {
        this.vgnService.setMinimalNav(false);
        this.subs.unsubscribe();
    }

    private adobePageLoad(): void { }

    private adobeGetStartedInfoOnly(): void { }

    private adobeGetStartedLimited(): void { }

    onGetStartedClicked(): void {
        this.subs.add(
            this.granteeAccessType$.pipe(take(1)).subscribe((accessType) => {
                switch (accessType) {
                    case this.accessTypeSelection.INFORMATION_ONLY:
                        this.adobeGetStartedInfoOnly();
                        break;
                    case this.accessTypeSelection.LIMITED_ACCESS:
                        this.adobeGetStartedLimited();
                        break;
                }
                setTimeout(() => {
                    document.location.href = environment.GRANTEE_WEB_REG_URL;
                }, 50);
            }),
        );
    }
}
